import PropTypes from "prop-types";

import Loading from "@/components/core/layout/loading";

const settingsConfig = {
    text: {
        confirm: {
            warning:
                "Are you sure you want to publish all light group settings to devices?",
            buttons: {
                confirm: "Publish",
                deny: "Cancel",
            },
        },
    },
};

/**
 * Confirmation dialog for publishing all light group settings.
 *
 * @param root0 - The component props.
 * @param root0.onPublishAllConfirm - Callback when publish is confirmed.
 * @param root0.onPublishAllCancel - Callback when publish is cancelled.
 * @returns The rendered publish all confirmation dialog.
 */
const PublishAllConfirm = ({ onPublishAllConfirm, onPublishAllCancel }) => (
    <Loading
        type="dialog"
        onConfirm={onPublishAllConfirm}
        onDeny={onPublishAllCancel}
        confirmText={settingsConfig.text.confirm.buttons.confirm}
        denyText={settingsConfig.text.confirm.buttons.deny}
        message={settingsConfig.text.confirm.warning}
    />
);

PublishAllConfirm.propTypes = {
    onPublishAllConfirm: PropTypes.func.isRequired,
    onPublishAllCancel: PropTypes.func.isRequired,
};

export default PublishAllConfirm;
